if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');

        document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));
        const colorClassesToApply = this.dataset.productPageColorScheme.split(' ');
        colorClassesToApply.forEach((colorClass) => {
          document.querySelector('pickup-availability-drawer').classList.add(colorClass);
        });

        const button = this.querySelector('button');
        if (button)
          button.addEventListener('click', (evt) => {
            document.querySelector('pickup-availability-drawer').show(evt.target);
          });
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onDocumentPointerDownCapture = this.handleDocumentPointerDownCapture.bind(this);
        this.onDocumentClickCapture = this.handleDocumentClickCapture.bind(this);
        this.onBackdropClick = this.handleBackdropClick.bind(this);
        this.backdrop = null;
        this.normalizeDrawerSemantics();

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      normalizeDrawerSemantics() {
        this.setAttribute('role', 'region');
        this.removeAttribute('aria-modal');
      }

      isOutsideDrawerTarget(target) {
        if (!target) return false;
        if (target === this) return false;
        if (target.closest('pickup-availability-drawer')) return false;
        if (target.id === 'ShowPickupAvailabilityDrawer') return false;
        return true;
      }

      handleDocumentPointerDownCapture(evt) {
        if (!this.hasAttribute('open')) return;
        const target = evt.target;
        if (!this.isOutsideDrawerTarget(target)) return;
        evt.preventDefault();
      }

      handleDocumentClickCapture(evt) {
        if (!this.hasAttribute('open')) return;
        const target = evt.target;
        if (!this.isOutsideDrawerTarget(target)) return;

        evt.preventDefault();
        evt.stopPropagation();
        if (typeof evt.stopImmediatePropagation === 'function') evt.stopImmediatePropagation();
        this.hide();
      }

      ensureBackdrop() {
        if (this.backdrop && this.backdrop.isConnected) return;

        const backdrop = document.createElement('div');
        backdrop.className = 'pickup-availability-backdrop';
        backdrop.setAttribute('aria-hidden', 'true');
        backdrop.addEventListener('click', this.onBackdropClick);
        this.backdrop = backdrop;
      }

      handleBackdropClick(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (typeof evt.stopImmediatePropagation === 'function') evt.stopImmediatePropagation();
        this.hide();
      }

      hide() {
        this.removeAttribute('open');
        document.removeEventListener('pointerdown', this.onDocumentPointerDownCapture, true);
        document.removeEventListener('click', this.onDocumentClickCapture, true);
        document.body.classList.remove('overflow-hidden');

        if (this.backdrop) {
          const backdropToRemove = this.backdrop;
          backdropToRemove.classList.remove('is-visible');
          setTimeout(() => {
            if (backdropToRemove.isConnected) backdropToRemove.remove();
          }, 200);
        }

        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        this.ensureBackdrop();
        if (this.backdrop && !this.backdrop.isConnected) {
          document.body.appendChild(this.backdrop);
          requestAnimationFrame(() => {
            if (this.backdrop) this.backdrop.classList.add('is-visible');
          });
        }
        document.addEventListener('pointerdown', this.onDocumentPointerDownCapture, true);
        document.addEventListener('click', this.onDocumentClickCapture, true);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }
    }
  );
}
